import { useTranslation } from 'react-i18next';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { MenuRecipeSummary } from '../types';
import CarbonRatingChip from '../../RecipeV2/components/CarbonRatingChip';

interface CarbonAndSustainabilityTabProps {
  recipeSummaries: MenuRecipeSummary[];
}

/** Carbon rating per dish, aggregated live from RecipeV2 (via
 * menusClient.getRecipeSummariesForMenu) rather than duplicated onto the Menu record. */
const CarbonAndSustainabilityTab = ({ recipeSummaries }: CarbonAndSustainabilityTabProps) => {
  const { t } = useTranslation('menus');

  if (recipeSummaries.length === 0) {
    return (
      <Paper variant="outlined"
        sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {t('noDishes', 'This menu has no dishes to cost yet.')}
        </Typography>
      </Paper>
    );
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('dish', 'Dish')}</TableCell>
            <TableCell>{t('carbon', 'Carbon')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {recipeSummaries.map((summary) => (
            <TableRow key={summary.recipeId}>
              <TableCell>{summary.recipeName}</TableCell>
              <TableCell><CarbonRatingChip rating={summary.carbonRating} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CarbonAndSustainabilityTab;
